module.exports = __webpack_public_path__ + "media/images/error-4aa1fd4422f6bf72d650725d73915b60.svg";